"use client"

import { useEffect, useState } from "react"

export const useMounted = () => {
  const [isMounted, setMounted] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- mount flag (SSR hydration guard); setState-in-effect is the intended pattern here
    setMounted(true)
  }, [])

  return isMounted
}
